import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../primary-nav/primary-nav.service';

@Component({
    selector: 're-primary-about',
    templateUrl: './primary-about.component.html',
    styleUrls: ['./primary-about.component.scss'],
    standalone: false
})
export class PrimaryAboutComponent implements OnInit {

    constructor(public nav: NavbarService) { }

  ngOnInit() {
      //this.nav.hide();
  }

}
